export default function enableKeyborad(
  map,
  deltaDistance = 100,
  deltaDegrees = 25
) {
  function easing(t) {
    return t * (2 - t)
  }
  map.on('load', function() {
    map.getCanvas().focus()
    map.getCanvas().addEventListener(
      'keydown',
      function(e) {
        e.preventDefault()
        if (e.which === 38) {
          // up
          map.panBy([0, -deltaDistance], {
            easing: easing
          })
        } else if (e.which === 40) {
          // down
          map.panBy([0, deltaDistance], {
            easing: easing
          })
        } else if (e.which === 37) {
          // left
          map.easeTo({
            bearing: map.getBearing() - deltaDegrees,
            easing: easing
          })
        } else if (e.which === 39) {
          // right
          map.easeTo({
            bearing: map.getBearing() + deltaDegrees,
            easing: easing
          })
        }
      },
      true
    )
  })
}



// WEBPACK FOOTER //
// ./src/framework/map/tool/keyborad.js